import React, { useState } from 'react';
import { 
    DefaultButton, 
    Panel, 
    PanelType,
    IPanelStyles,
    Text,
    TextField,
} from '@fluentui/react';
import ErrorMessageComponent from '../error-message/error-message.component';

const panelStyles : IPanelStyles = {
    root: {},
    overlay: {},
    hiddenPanel: {},
    main: {},
    commands: {},
    contentInner: {},
    scrollableContent: {},
    navigation: {},
    header: {},
    headerText: {},
    content: {},
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: 'rgb(50, 49, 48)',
            },
        },
    },
};

interface IDynamicFormFieldValueComponentProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (value: string) => void;
    value?: string;
};

const DynamicFormFieldValueComponent = (props: IDynamicFormFieldValueComponentProps) => {
    const [value, setValue] = useState<string>(props.value ? props.value : "");
    const [error, setError] = useState<string>('');

    const onChangeValue = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) : void => {
        setValue(newValue || "");
    };

    const onDismiss = () : void => {
        setValue("");
        props.onClose();
    };

    const onSubmit = () : void => {
        if (!value) {
            setError("Complete el valor del elemento de lista.")
        }
        else {
            props.onConfirm(value);
            props.onClose();
        }
    };

    return (
        <Panel 
            id="ModalCrearFormularioCampoValor" 
            isOpen={props.isOpen} 
            onDismiss={onDismiss} 
            type={PanelType.largeFixed}
            headerText={props.value ? 'Modificar elemento de lista' : 'Nuevo elemento de lista'}
            styles={panelStyles}>
            <div className="container-fluid p-0">
                <div className="row m-0">
                    <div className='col-12'>
                        <Text className="my-1 d-block">
                            Valor:
                        </Text>
                        <TextField
                            defaultValue={value}
                            onChange={onChangeValue} />
                    </div>
                    <div className='col-12 mt-3'>
                        <DefaultButton 
                            text='Aceptar'
                            iconProps={{
                                iconName: 'Save',
                            }}
                            onClick={onSubmit} />
                    </div>
                </div>
            </div>
            <ErrorMessageComponent message={error} />
        </Panel>
    );
};

export default DynamicFormFieldValueComponent;
